import { heroStats } from "@/mocks/manga";

export default function Hero() {
  const scrollTo = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="relative flex min-h-[92vh] w-full items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20a%20young%20couple%20standing%20close%20under%20a%20crimson%20and%20gold%20dusk%20sky%20filled%20with%20floating%20rose%20petals%2C%20soft%20painterly%20brushstrokes%2C%20cinematic%20warm%20lighting%20in%20deep%20rose%20and%20amber%20tones%2C%20dreamy%20nostalgic%20romance%20atmosphere%2C%20elegant%20artistic%20manga%20key%20visual%2C%20no%20text&width=1600&height=1000&seq=sp-hero-2026&orientation=landscape"
        alt="甜蜜惩罚漫画 剧情追踪站首屏背景图"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/70" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
            <i className="ri-book-open-line" />
            剧情向连载追踪站 · 持续更新中
          </span>

          <h1 className="font-heading mt-6 text-4xl leading-tight text-background-50 md:text-6xl">
            甜蜜惩罚漫画
          </h1>
          <p className="mt-3 font-heading text-xl text-accent-200 md:text-2xl">
            剧情主线与角色结局追踪 · 分话人物解析
          </p>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            这里为你系统梳理《甜蜜惩罚》的主线走向与关键分话节点，盘点复杂纠缠的角色关系与人物命运，
            结局线索持续追踪更新。无论是刚入坑的新读者，还是追更多年的老粉，都能在这里理清脉络、不再迷路。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => scrollTo("plot")}
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              从主线开始追更
            </button>
            <button
              type="button"
              onClick={() => scrollTo("characters")}
              className="whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:border-background-50 hover:bg-background-50/10"
            >
              先认识核心角色
            </button>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/20 bg-background-50/10 px-4 py-4 text-center backdrop-blur"
            >
              <div className="font-heading text-3xl text-accent-200">{s.value}</div>
              <div className="mt-1 text-sm text-background-100">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}